/* eslint-disable no-return-assign, react/no-unused-state */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import {
  Button, Container, Icon, Image, Input, Segment
} from 'semantic-ui-react';

import iconAccessCode from '../img/icon-access-code.svg';
import iconCourse from '../img/icon-course.svg';
import iconPieBlack from '../img/icon-pie-black.svg';
import iconRoster from '../img/icon-roster.svg';
import iconUser from '../img/icon-user.svg';

import '../css/AdminSchoolCard.less';

import imageBlueBackground from '../img/image-blue-background.png';

import { ADMIN_SCHOOL_CARD_OPTION } from '../constants/AdminSchoolCardConstants';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { REPORT_FACULTY_TYPE } from '../services/reports/ReportConstants';

import { DIALOG_NAMES } from '../managers/DialogManager';
import { VIEW_SELECTION } from '../managers/NavigationManager';

@inject('dialogManager', 'navigationManager', 'schoolManager', 'userManager')
@observer
class AdminSchoolCard extends Component {
  constructor(props) {
    super(props);
    this.GenericModal = SatCoreComponent('GenericModal');
    this.state = {
      accessCodeSchool: null,
      directSchoolImageUrl: '',
      fullImageUrl: '',
      isAccessCodeModalOpen: false
    };
  }

  async componentDidMount() {
    const { school } = this.props;
    if (school.imageContentItemId) {
      await this.fetchDirectSchoolImageUrl(school);
    }
  }

  fetchDirectSchoolImageUrl = async (school) => {
    const { schoolManager, userManager } = this.props;
    if (school.imageContentItemId) {
      schoolManager.fetchDirectSchoolImageUrl(
        school, userManager.authKey)
        .then(({ fullImageUrl, directSchoolImageUrl }) => {
          this.setState({
            directSchoolImageUrl: directSchoolImageUrl ? `${directSchoolImageUrl}` : null,
            fullImageUrl: fullImageUrl ? `${fullImageUrl}` : null,
          });
        });
    }
  }

  handleClickImagePicker = () => {
    this.toggleSchoolImageEditor();
  }

  toggleSchoolImageEditor = (fullImageUrl = null, directSchoolImageUrl = null) => {
    const { dialogManager, school } = this.props;
    if (dialogManager.openedDialogs.has(DIALOG_NAMES.SCHOOL_IMAGE)) {
      dialogManager.closeDialog(DIALOG_NAMES.SCHOOL_IMAGE);
      this.setState({
        directSchoolImageUrl: directSchoolImageUrl ? `${directSchoolImageUrl}` : null,
        fullImageUrl: fullImageUrl ? `${fullImageUrl}` : null,
      });
    } else {
      dialogManager.setOpenDialog(DIALOG_NAMES.SCHOOL_IMAGE, {
        school
      }, this.toggleSchoolImageEditor);
    }
  }

  handleClickAccessCode = async (_event, _data) => {
    const { school, schoolManager } = this.props;
    const accessCodeSchool = schoolManager.getSchool(school.id) || school;
    this.setState({
      accessCodeSchool,
      isAccessCodeModalOpen: true
    });
  }

  handleCloseAccessCodeModal = () => {
    this.setState({
      accessCodeSchool: null,
      isAccessCodeModalOpen: false
    });
  }

  handleClickUsers = async (_event, _data) => {
    const { history, navigationManager, school } = this.props;
    const { id, name, parentId } = school;
    navigationManager.setView(VIEW_SELECTION.USERS);
    const routerUrl = `/users?view=${VIEW_SELECTION.USERS}&institutionId=${id}&districtId=${parentId}&institutionName=${name}`;
    await history.push(routerUrl);
  }

  handleClickProducts = async (_event, _data) => {
    const { history, navigationManager, school, userManager } = this.props;

    const { canViewSatelliteProducts, canViewSatelliteContent } = userManager;

    const { id, name, parentId } = school;
    let routerUrl = '';
    if (canViewSatelliteContent && !canViewSatelliteProducts) {
      navigationManager.setView(VIEW_SELECTION.CONTENT);
      routerUrl = `/content?view=${VIEW_SELECTION.CONTENT}`;
    } else {
      navigationManager.setView(VIEW_SELECTION.PRODUCTS);
      routerUrl = `/products?view=${VIEW_SELECTION.PRODUCTS}&institutionId=${id}&districtId=${parentId}&institutionName=${name}`;
    }
    await history.push(routerUrl);
  }

  handleClickClassrooms = async (_event, _data) => {
    const { history, navigationManager, school } = this.props;
    const { id, name, parentId } = school;
    navigationManager.setView(VIEW_SELECTION.CLASSROOMS);
    const routerUrl = `/classrooms?view=${VIEW_SELECTION.CLASSROOMS}&institutionId=${id}&districtId=${parentId}&institutionName=${name}`;
    await history.push(routerUrl);
  }

  handleClickReports = async (_event, _data) => {
    const { history, navigationManager, school } = this.props;
    const { id, name, parentId } = school;
    navigationManager.setView(VIEW_SELECTION.REPORTS);

    let routerUrl = `/reports?view=${VIEW_SELECTION.REPORTS}`;
    routerUrl += `&institutionId=${id}`;
    routerUrl += `&districtId=${parentId}`;
    routerUrl += `&institutionName=${name}`;
    routerUrl += `&reportFacultyType=${REPORT_FACULTY_TYPE.SCHOOL}`;
    await history.push(routerUrl);
  }

  renderOption(name, prefix, src, onClick) {
    return (
      <Button onClick={onClick}>
        <div className={`admin-school-card-option-${prefix}-wrapper`}>
          <div className={`admin-school-card-option-${prefix}-icon`}>
            <Image alt='' src={src} />
          </div>
          <div className={`admin-school-card-option-${prefix}-label`}>
            {name}
          </div>
        </div>
      </Button>
    );
  }

  renderAccessCodeModalBody = () => {
    const { school, t } = this.props;
    const { accessCodeSchool } = this.state;
    const accessCodeSchoolData = accessCodeSchool || school;

    return (
      <div className='admin-school-access-code-modal-body'>
        <div className='admin-school-access-code-field'>
          <div className='admin-school-access-code-label'>
            {t('teacherAccessCodeLabel', 'Teacher Access Code')}
          </div>
          <Input
            className='admin-school-access-code-input'
            readOnly
            value={accessCodeSchoolData?.teacherSignUpCode || ''} />
        </div>
      </div>
    );
  }

  renderAdminSchoolCardOption = (key) => {
    const { schoolManager, userManager, t } = this.props;

    const { allowAdminSchoolCardProductsLink } = schoolManager;

    const {
      canViewClassroomsAsAdmin,
      canViewSatelliteContent,
      canViewSatelliteProducts,
      canViewReportsAsAdmin,
      canViewUsersAsAdmin
    } = userManager;

    switch (key) {
      case ADMIN_SCHOOL_CARD_OPTION.ACCESS_CODE:
        return this.renderOption(t('accessCodeLabel', 'Access Code'), 'accessCode', iconAccessCode, this.handleClickAccessCode);
      case ADMIN_SCHOOL_CARD_OPTION.USERS:
        return canViewUsersAsAdmin
          ? this.renderOption(t('usersLabel', 'Users'), 'users', iconUser, this.handleClickUsers)
          : null;
      case ADMIN_SCHOOL_CARD_OPTION.PRODUCTS:
        return (canViewSatelliteProducts || canViewSatelliteContent) && allowAdminSchoolCardProductsLink
          ? this.renderOption(t('productsLabel', 'Products'), 'products', iconCourse, this.handleClickProducts)
          : null;
      case ADMIN_SCHOOL_CARD_OPTION.CLASSES:
        return canViewClassroomsAsAdmin
          ? this.renderOption(t('classesLabel', 'Classes'), 'classes', iconRoster, this.handleClickClassrooms)
          : null;
      case ADMIN_SCHOOL_CARD_OPTION.REPORTS:
        return canViewReportsAsAdmin
          ? this.renderOption(t('reportsLabel', 'Reports'), 'reports', iconPieBlack, this.handleClickReports)
          : null;
      default:
        return null;
    }
  }

  render() {
    const {
      school,
      schoolManager,
      t
    } = this.props;

    const { GenericModal } = this;

    const { adminSchoolCardOptionsOrderArray } = schoolManager;

    const {
      directSchoolImageUrl,
      isAccessCodeModalOpen
    } = this.state;

    return (
      <Container className='admin-school-card-container'>
        <Segment key='tempkey' className='admin-school-card-segment-wrapper'>
          <div className='admin-school-card'>
            <div className={`admin-school-card-image
              ${!directSchoolImageUrl ? 'default-image' : ''}`}>
              {directSchoolImageUrl ? (
                <Image
                  onError={(event) => event.target.src = imageBlueBackground}
                  src={directSchoolImageUrl} />
              ) :
                null}
            </div>
            <div className='admin-school-card-image-icon'>
              <Icon
                name='ellipsis horizontal'
                onClick={() => this.handleClickImagePicker()} />
            </div>
            <div className='admin-school-card-title'>
              <span className='admin-school-card-title-text'>
                {school.name}
              </span>
            </div>
            <div className='admin-school-card-options'>
              {adminSchoolCardOptionsOrderArray.map((key) => (
                <React.Fragment key={key}>
                  {this.renderAdminSchoolCardOption(key)}
                </React.Fragment>
              ))}
            </div>
          </div>
        </Segment>
        <GenericModal
          actionButtonOrderArray={['cancel']}
          bodyMsg={this.renderAccessCodeModalBody}
          buttonKeyCancelLabel={t('closeLabel', 'Close')}
          buttonKeyConfirmLabel=''
          className='admin-school-access-code-modal'
          headerMsg={t('accessCodeLabel', 'Access Code')}
          initHeight={230}
          initWidth={500}
          isOpen={isAccessCodeModalOpen}
          onClose={this.handleCloseAccessCodeModal}
          overlay='medium' />
      </Container>
    );
  }
}
export default AdminSchoolCard;

SatCoreRegister('AdminSchoolCard', AdminSchoolCard);
